import React, {useEffect, useRef, useState} from 'react';

const Dropdown = ({elements}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    if (showDropdown) {
      document.addEventListener('click', handleClickOutside);
    }

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [showDropdown]);

  return (
    <div ref={dropdownRef} style={{zIndex: 99999}}>
      {!!elements.filter(Boolean).length && (
        <div className='sheets__table-threeDots'>
          <img
            className='agencyCard__action-btn'
            src='/assets/icons/dots.svg'
            alt='dots'
            onClick={e => {
              e.stopPropagation();
              setShowDropdown(true);
            }}
          />
        </div>
      )}
      {showDropdown && (
        <div className='trial__dropdown'>
          {elements
            .filter(el => Boolean(el))
            .map((element, index) => (
              <div
                className='trial__dropdown-elem'
                onClick={e => {
                  e.stopPropagation();
                  element.onClick();
                }}
                key={index}
              >
                {element.icon}
                <span style={{color: element.labelColor}}>{element.label}</span>
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

export default Dropdown;
